import { translateDataToTree, responseFormat } from '@/utils'
import {
  UPDATE_TOKEN,
  UPDATE_USER_INFO,
  UPDATE_PERMISSIONS
} from './mutation-types'
export default {
  [UPDATE_TOKEN]: (state, payload) => {
    state.token = payload
  },
  [UPDATE_USER_INFO]: (state, payload) => {
    state.userInfo = payload
    // 检查是否为客户账号（通过 is_customer 字段或 project_id 字段判断）
    //state.isCustomer = payload.is_customer === 1 || payload.is_customer === '1' || !!payload.project_id
    //state.customerProjectId = payload.project_id || null
  },
  [UPDATE_PERMISSIONS]: (state, payload = []) => {
    // 找出前台权限项
    const current = responseFormat.string2number(payload, ['parent_id'], true).filter(item => item.type === '1')
    const permissions = []
    const operateAuth = []
    const healths = []
    const xunjian = []
    const survey = []  // survey项目菜单

    for (let item of current) {
      if (item.uri) {
        permissions.push(item.uri)
        // 根据 project 字段分类
        if (item.project === 'survey') {
          survey.push(item)
        } else if (/\/xunjian/.test(item.uri)) {
          xunjian.push(item)
        } else {
          healths.push(item)
        }
      } else if (item.prop) {
        operateAuth.push(item.prop)
      }
    }
    state.allPermissions = current
    // 路由权限
    state.permissions = permissions
    // 操作权限
    state.operateAuth = operateAuth

    state.routes = translateDataToTree(healths)
    state.xunjianRoutes = translateDataToTree(xunjian)
    state.surveyRoutes = translateDataToTree(survey)  // survey项目路由

    // 判断是否为客户账号（只有bzmj权限）
    const hasBzmjOnly = current.length > 0 && current.every(p => p.uri && p.uri.startsWith('/bzmj'))
    if (hasBzmjOnly && !state.isCustomer) {
      state.isCustomer = true
    }
  },
  updateSelect(state, payload) {
    state.commonSelect = payload
  },
  // 设置客户账号状态
  SET_CUSTOMER_STATUS(state, { isCustomer, projectId }) {
    state.isCustomer = isCustomer
    state.customerProjectId = projectId
  }
}
